import React from "react";

const Parking = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-parking"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-Parking"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm1.5,14h-4.5v4c0,.552-.447,1-1,1s-1-.448-1-1V9c0-2.206,1.794-4,4-4h2.5c2.481,0,4.5,2.019,4.5,4.5s-2.019,4.5-4.5,4.5Zm2.5-4.5c0,1.378-1.121,2.5-2.5,2.5h-4.5v-3c0-1.103,.897-2,2-2h2.5c1.379,0,2.5,1.122,2.5,2.5Z" />
    </svg>
  );
};

export default Parking;
